var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticStyle:{"display":"block","margin":"10px 0"},attrs:{"href":"https://go.qlipper.jp/l/1053513/2024-05-05/378hf6","target":"_blank"}},[_c('img',{attrs:{"src":"img/introduction.png"}})])
}]

export { render, staticRenderFns }